import React, {ReactElement, useState} from 'react';
import {setAppBarTitle, setBackNavEnabled} from '../../redux/globalSlice';
import {useAppDispatch, useAppSelector} from '../../redux/hooks';
import {useEffect} from 'react';
import CustomModal from '../../components/modal/CustomModal';
import Card from './Card';
import OrderSummary from '../checkout/confirm/OrderSummary';
import {getAccessToken} from '../../core/localstorage-data';
import {fetchAllOrders, allOrders} from '../../redux/orderSlice';
import {ItemListType, OrderResponse} from '../../lib/order-types';

const TodaysOrders = (): ReactElement => {
  const [active, setActive] = useState('detagging');
  const [activeOrderId, setActiveOrderId] = useState('');
  const allOrdersResp = useAppSelector(allOrders);
  const [showOrderSummaryModal, setShowOrderSummaryModal] = useState(false);
  const [currentOrder, setCurrentOrder] = useState<OrderResponse | null>(null);
  const dispatch = useAppDispatch();
  const accessToken = getAccessToken();
  useEffect(() => {
    dispatch(setAppBarTitle('My Orders'));
    dispatch(setBackNavEnabled(true));
    if (accessToken) {
      dispatch(fetchAllOrders(accessToken));
    }
    return () => {
      // Clean up the subscription
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
    };
  }, [setAppBarTitle]);

  useEffect(() => {
    if (allOrdersResp) {
      //console.log(allOrdersResp);
    }
  }, [allOrdersResp]);

  function handleDetaggingClick() {
    setActive('detagging');
    setActiveOrderId('');
  }
  function handleCompletedClick() {
    setActive('completed');
    setActiveOrderId('');
  }
  function handlePendingComplete() {
    setActive('failed');
    setActiveOrderId('');
  }

  function handleCardClick(type: string, order: OrderResponse) {
    setActiveOrderId(order.orderId);
    setCurrentOrder(order);
    console.log('card is clicked', type);
    setShowOrderSummaryModal(true);
  }

  function renderTodaysOrders() {
    if (allOrdersResp === null) {
      return <div>No Order Available</div>;
    } else {
      return renderOrdersList();
    }
  }

  function renderOrdersList() {
    return (
      <>
        <div className="px-4 py-6">
          <div className="mb-8 flex text-center">
            <div
              className={`py-2.5 px-4 font-roboto ${
                active === 'detagging'
                  ? 'text-white bg-blue_zero rounded-2xl'
                  : 'text-black text-opacity-80'
              }`}
              onClick={handleDetaggingClick}>
              De-tagging pending
            </div>
            <div
              className={`py-2.5 px-4 font-roboto ${
                active === 'completed'
                  ? 'text-white bg-blue_zero rounded-2xl'
                  : 'text-black text-opacity-80'
              }`}
              onClick={handleCompletedClick}>
              Completed
            </div>
            <div
              className={`py-2.5 px-4 font-roboto ${
                active === 'failed'
                  ? 'text-white bg-blue_zero rounded-2xl'
                  : 'text-black text-opacity-80'
              }`}
              onClick={handlePendingComplete}>
              Others
            </div>
          </div>

          {active === 'completed'
            ? allOrdersResp &&
              allOrdersResp &&
              allOrdersResp.map((order: OrderResponse, index) => {
                if (
                  order.isCompleted &&
                  order.hasDetagged &&
                  order.isFailed === false
                ) {
                  return (
                    <Card
                      key={index}
                      type={active}
                      activeOrder={activeOrderId}
                      onCardClick={type => handleCardClick(type, order)}
                      order={order}
                    />
                  );
                }
              })
            : active === 'detagging'
            ? allOrdersResp &&
              allOrdersResp &&
              allOrdersResp.map((order: OrderResponse, index) => {
                if (
                  order.isCompleted &&
                  !order.hasDetagged &&
                  order.isFailed === false
                ) {
                  return (
                    <Card
                      key={index}
                      type={active}
                      activeOrder={activeOrderId}
                      onCardClick={type => handleCardClick(type, order)}
                      order={order}
                    />
                  );
                }
              })
            : allOrdersResp &&
              allOrdersResp &&
              allOrdersResp.map((order: OrderResponse, index) => {
                if (
                  (order.isCompleted === true &&
                    order.hasDetagged === false &&
                    order.isFailed === true) ||
                  (order.paymentInitiated === true &&
                    order.isCompleted === false)
                ) {
                  return (
                    <Card
                      key={index}
                      type={active}
                      activeOrder={activeOrderId}
                      onCardClick={type => handleCardClick(type, order)}
                      order={order}
                    />
                  );
                }
              })}

          {/* <Card type={active} onCardClick={handleCardClick} />
          <Card type={active} onCardClick={handleCardClick} /> */}
        </div>
        <CustomModal
          isVisible={showOrderSummaryModal}
          classNames="top-20 md:top-72"
          onClose={() => {
            setShowOrderSummaryModal(false);
          }}>
          {currentOrder && (
            <OrderSummary type={active} orderResp={currentOrder} />
          )}
        </CustomModal>
      </>
    );
  }

  return renderTodaysOrders();
};

export default TodaysOrders;
